<template>
	<el-tooltip class="item" effect="dark" :content="serviceCenter" placement="top">
		<el-select default-first-option clearable @clear="clear" :style="{width: selectWidth}" :size="selectSize" :multiple="multiple" :filter-method="filterText" value-key="ID" v-model="selectValues" @change="selectChanged" :collapse-tags="isCollapsed" @input="handleInput" filterable placeholder="请选服务台">
			<el-option v-for="item in serviceList" :key="item.ID" :label="item.NAME" :value="item.ID">
				<span style="float: left">{{ item.NAME }}</span>
				<span style="float: right; color: #8492a6;">{{ item.DEPTNAME+' - '+item.COMPANYNAME }}</span>
			</el-option>
		</el-select>
	</el-tooltip>

</template>

<script>
	import { GetAllServerCenter } from "@/api/modules/basicData/organization";
	export default {
		name: "selectService",
		props: {
			originValues: {
				type: String,
				default: ""
			},
			multiple: {
				type: Boolean,
				default: false
			},
			selectWidth: {
				type: String,
				default: "250px"
			},
			selectSize: {
				type: String,
				default: "-"
			},
			isCollapsed: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				serviceList: [],
				selectValues: [],
				seleted: "",
				serviceCenter: ''
			};
		},
		mounted() {},
		created() {
			//	this.setOption()
			this.getServiceList("");
			var _ = require("lodash");
			this.debouncedSearch = _.debounce(this.getServiceList, 1000);
		},
		methods: {
			selectChanged(vId) {
				this.$emit("selectChanged", this.selectValues);
				console.log(vId, "vid");
				var arr = [];
				this.serviceList.forEach((a) => {
					vId.forEach((c) => {
						if(a.ID == c) {
							arr.push(a.NAME);
						}
					})
				})
				console.log(arr,"arr")
				this.serviceCenter = arr.join(",")
				this.$store.state.task.serviceCenterName = this.serviceCenter
			},
			setOption() {
				if(this.setWidth != null) {
					this.myWidth = this.setWidth;
				}
				if(this.setSize != null) {
					this.size = this.setSize;
				}
			},
			clear() {
				this.getServiceList("");
			},
			filterText(val) {
				this.debouncedSearch(val);
			},
			getServiceList(val) {
				GetAllServerCenter(val).then(response => {
					console.log(response, "response");
					this.serviceList = response;
					this.$store.state.task.serviceCenterList = response;
				});
			},
			handleInput(val) {
				//this.company = val;
				this.$emit("input", val); //触发 input 事件，并传入新值
			}
		},
		watch: {
			originValues(newValue, oldValue) {
				if(newValue) {
					this.selectValues = newValue.split(',');
				} else {
					this.selectValues = [];
				}
			}
		},
		computed: {}
	};
</script>

<style scoped>

</style>